import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "heroicons-solid/star",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Star 5 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7874 4.04402C11.2357 2.96607 12.7627 2.96607 13.2111 4.04402L15.2931 9.04973L20.6972 9.48297C21.8609 9.57627 22.3328 11.0286 21.4461 11.7881L17.3288 15.315L18.5867 20.5885C18.8576 21.7241 17.6222 22.6217 16.6259 22.0131L11.9992 19.1872L7.37256 22.0131C6.37624 22.6217 5.14084 21.7241 5.41173 20.5885L6.66964 15.315L2.5523 11.7881C1.66566 11.0286 2.13753 9.57627 3.30127 9.48297L8.70536 9.04973L10.7874 4.04402Z",
			fill: "#FFA800"
		})
	})
});
export default SvgStar;
